import { get } from "services/actions";
import qs from 'qs';
import AppLayout from "components/AppLayout";
import ImoveisPage from "components/pages/Imoveis";
import { PropertiesProvider } from "context/propertiesContext";
import strapiImg from "utils/strapiImg";


export default function Imoveis({
  appLayout,
  imoveisPage,
  cidades,
  ufs,
  fases,
  page,
  query,
  cities,
  numberProperties,
}) {
  return (
    <>
      <AppLayout data={appLayout}>
        <PropertiesProvider
          properties={imoveisPage.imoveis}
          numberProperties={numberProperties}
          cities={cidades}
          ufs={ufs}
          phases={fases}
          pagination={page}
          query={query}
          citiesUfs={cities}
        >
          <ImoveisPage data={imoveisPage} />
        </PropertiesProvider>
      </AppLayout>
    </>
  );
}

export async function getServerSideProps({ query: { page = 1, ...rest } }) {
  const query = qs.stringify({
    _where: [
      {
        'cidades.uf': rest.ESTADO,
        'cidades.slug': rest.CIDADE,
        'etapas_imovel.slug': rest.FASE
      }
    ]
  }, { addQueryPrefix: true, encode: true })

  const header = await get("cabecalho");
  const footer = await get("rodape");
  const numberProperties = await get(`imoveis/count${query}`);
  const properties = await get(`imoveis${query}`, {
    _limit: 9,
    _start: +page === 1 ? 0 : (+page - 1) * 9,
    _sort: 'etapas_imovel:ASC'
  });

  const cities = await get("cidades");
  const phases = await get("etapas-imovels");
  const receiveNews = await get("receba-novidades");
  const data = await get("pg-imovel");

  // DADOS AppLayout
  const appLayout = {
    header: {
      logo: strapiImg(header.logo, "", true),
      menu: header.menu,
    },
    footer: {
      logo: strapiImg(footer.logo, "", true),
      redes: footer.redes_sociais.map(({ id, nome, link, icone }) => {
        icone = strapiImg(icone, "", true);
        return {
          id,
          nome,
          link,
          icone,
        };
      }),
      unidades: footer.unidades,
      submenus: footer.submenu,
      whatsappIcon: strapiImg(footer?.icone_whatsapp_rodape, "", true),
      openChatBot: footer?.habilitar_chatbot
    },
  };

  // DADOS imoveisPage
  const imoveisPage = {
    seo: {
      titulo: data.SEO ? data.SEO.title : "",
      descricao: data.SEO ? data.SEO.description : "",
      imagem: data.SEO ? strapiImg(data.SEO.image, "", true) : "",
    },
    imoveis: properties.map((item) => {
      return {
        id: item.id,
        nome: item.nome,
        cidades: item.cidades,
        etapasImovel: item.etapas_imovel,
        tipologia: item.tipologia,
        descricao: item.descricao,
        slug: item.slug,
        imagemCard: strapiImg(item.imovel_imagem, "", true),
      };
    }),
    secaoRecebaNovidades: {
      imagem: strapiImg(receiveNews.background_imagem, "", true),
      email: receiveNews.email_de_envio,
    },
  };

  // INFORMAÇÕES PARA A SearchBar
  const cidades = cities.map((city) => {
    return {
      id: city.id,
      nome: city.cidade,
    };
  });

  // INFORMAÇÕES PARA A SearchBar
  const ufs = cities.reduce((unique, o) => {
    if (!unique.some((obj) => obj.uf === o.uf)) {
      unique.push({
        id: o.id,
        uf: o.uf,
      });
    }
    return unique;
  }, []);

  // INFORMAÇÕES PARA A SearchBar
  const fases = phases.map((phase) => {
    return {
      id: phase.id,
      fase: phase.etapa,
    };
  });

  return {
    props: {
      appLayout,
      imoveisPage,
      cidades,
      ufs,
      fases,
      page: +page,
      numberProperties,
      query,
      cities
    },
  };
}
